import React from 'react';
import PropTypes from 'prop-types';
import ClusterSegmentSummary from './ClusterSegmentSummary';
import ClusterSegmentComparison from './ClusterSegmentComparison';

const ClusterDataView = props => {
  const {
    project: { selectedCluster, clusterResponse },
  } = props;
  const solutions = clusterResponse && clusterResponse.solutions ? clusterResponse.solutions : [];

  if(solutions.length > 0) return (
    <div className="clusterOuterDiv" data-test="clusterOuterDiv">
      <ClusterSegmentSummary
        segmentData={selectedCluster > -1 ? solutions[selectedCluster].segments : undefined}
      />
      <ClusterSegmentComparison
        project= {props.project}
      />
    </div>
  );
  if(clusterResponse.errMsg) return (<div className="clusterOuterDiv" data-test="clusterOuterDiv">
    <div className="errorMessage">{clusterResponse.errMsg}</div>
    </div>);
  return null;
};

ClusterDataView.propTypes = {
  project: PropTypes.instanceOf(Object)
};

export default ClusterDataView;
